import { render, staticRenderFns } from "./ResetPasswordAlumni.vue?vue&type=template&id=5c296668"
import script from "./ResetPasswordAlumni.vue?vue&type=script&lang=js"
export * from "./ResetPasswordAlumni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports